export function normalizeInternalRedirect(value) {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== "string") return null;

  const next = raw.trim();
  if (!next || !next.startsWith("/") || next.startsWith("//")) {
    return null;
  }
  return next;
}

export function signinRedirectForRoute(route) {
  return {
    path: "/signin",
    query: {
      next: (route && (route.fullPath || route.path)) || "/home",
    },
  };
}

export function redirectLocationFromNext(next, routeQuery = {}, routeHash = "") {
  const target = normalizeInternalRedirect(next);
  if (!target) return null;

  // If next already carries its own query/hash, use it as the source of truth.
  // This preserves deep links like /banking?refund_payout_token=...
  if (target.includes("?") || target.includes("#")) {
    return target;
  }

  // Backward compatibility for sign-in pages created by the old guard as
  // /signin?next=/banking&refund_payout_token=...
  const query = { ...(routeQuery || {}) };
  delete query.next;
  return {
    path: target,
    query,
    hash: routeHash || undefined,
  };
}

export function pathFromRedirectLocation(location) {
  if (!location) return null;
  if (typeof location === "string") {
    return location.split(/[?#]/, 1)[0] || "/";
  }
  return location.path || null;
}

export function isPublicBootstrapPath(path) {
  const normalized = pathFromRedirectLocation(path) || "/";
  const segments = normalized.split("/").filter(Boolean);

  if (
    normalized === "/" ||
    normalized === "/home" ||
    normalized === "/search" ||
    normalized === "/signin" ||
    normalized === "/signup" ||
    normalized === "/forgot-password" ||
    normalized === "/reset-password" ||
    normalized === "/invite"
  ) {
    return true;
  }

  if (
    (segments[0] === "pitch" && segments.length === 2) ||
    (segments[0] === "users" && segments.length === 2) ||
    (segments[0] === "community" && segments.length === 2) ||
    (segments[0] === "strategies" && segments.length <= 2) ||
    (segments[0] === "investments" &&
      (segments.length === 2 ||
        segments.length === 4 ||
        (segments.length === 5 && segments[4] === "money-allocation"))) ||
    normalized.startsWith("/home-follow/unsubscribe/") ||
    normalized.startsWith("/abandoned-cart/unsubscribe/")
  ) {
    return true;
  }

  return false;
}
